import { render } from "./PoisListView.vue?vue&type=template&id=1c374464&scoped=true"
import script from "./PoisListView.vue?vue&type=script&lang=js"
export * from "./PoisListView.vue?vue&type=script&lang=js"

import "./PoisListView.vue?vue&type=style&index=0&id=1c374464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c374464"]])

export default __exports__